// frozen_string_literal: true

import { Controller } from "@hotwired/stimulus"

// Handles sidebar filter check-boxes and loading state on the category-location page.
export default class extends Controller {
  static targets = ["checkbox", "applyBtn", "loading"]

  connect() {
    // Hide apply button when JS active
    if (this.hasApplyBtnTarget) this.applyBtnTarget.style.display = "none";

    // Re-enable checkboxes (they may be disabled by previous navigation)
    this.checkboxTargets.forEach(cb => {
      cb.disabled = false;
      cb.dataset.processing = "false";
    });

    // Ensure spinner hidden
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add("d-none");
      this.loadingTarget.classList.remove("show");
    }
  }

  toggle(event) {
    const clicked = event.currentTarget;
    if (clicked.dataset.processing === "true") return;

    clicked.dataset.processing = "true";

    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("d-none");
      setTimeout(() => this.loadingTarget.classList.add("show"), 10);
    }

    // Disable all during transition
    this.checkboxTargets.forEach(cb => (cb.disabled = true));

    // Build new filter list
    const selected = this.checkboxTargets.filter(cb => cb.checked).map(cb => cb.value);

    const url = new URL(window.location.href);
    // Remove any existing filter params first
    url.searchParams.delete("filters");
    url.searchParams.delete("filters[]");
    selected.forEach(f => url.searchParams.append("filters[]", f));

    // Small delay so spinner becomes visible
    setTimeout(() => {
      window.location.href = url.toString();
    }, 300);
  }
}
